module.exports = __webpack_public_path__ + "img/modelo_small2.d910fceb.png";